export const TRANSLATIONS_EN_US = {
  labels: {
    show_map: "Show map",
    submission_guideline: "Submission Guidelines",
    delete_custom_documents: "Delete Custom Documents",
    search_by_foundation_name: "Search by Foundation Name...",
    explore_funding: "Explore Funding Opportunities across the US!",
    explore_funding_ca: "Explore Funding Opportunities across Canada!",
    watch_demo_slides: "Watch Demo Slides",
    join_live_webinar: "Join a Live Q & A Webinar",
    register_webinar: "Register for our Live Webinar",
    roadmap_success_guide: "Roadmap to Success Guide",
    charities_helping_charities_title: "Charities Helping Charities Referral Program",
    you_got_funded: "You Got Funded. Claim Your Bonus.",
    report_your_successful_grant: "Report your successful grant and unlock $25 in Grant Advance credits — instantly.",
    refer_charity_earn_bonus: "Refer a Charity & Earn Bonus time!",
    optimal_browser_use: "Optimal Browser Use",
    browser_recommendation: "For the best experience, we recommend using the latest versions of Chrome or Firefox.",
    roadmap_success_pdf: "Roadmap to Success.pdf",
    charities_program_form: "Charities Helping Charities Program Form.pdf",
    refer_a_charity: "Refer a Charity",
    register_webinar: "Register for our Live Webinar",
    user_name: 'Username',
    password: 'Password',
    reset_password: 'New Password',
    reset_password_confirm: 'Confirm Password',
    login: 'Login',
    sign_up: "Sign Up",
    forgot_password: "Forgot Password?",
    go_back: "Go Back",
    organization: "Organization",
    phone: "Phone",
    first_name: "First Name",
    last_name: "Last Name",
    address: "Address",
    select: "Select",
    country: "Country",
    complementary_address: "Address (line 2)",
    postal_code: "Zip/Postal Code",
    city: "City",
    state: "State",
    stateOrProvince: "State/Province",
    billing: "Billing",
    use_same_address: "Use Same Address",
    loading: "Loading...",
    register: "Register",
    message: "Message",
    error: "Error",
    welcome_back: "Hi, Welcome back",
    enter_credentials: "Enter your credentials to continue",
    dont_have_account: "Don't have an account?",
    remember_me: "Remember me",
    sign_in: "Sign in",
    already_have_account: "Already have an account?",
    subscription_plan: "Subscription Plan",
    country_billing: "Country Billing",
    password_recovery: "Password recovery",
    password_reset: "Password Reset",
    setting_up_account: "Setting up account",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    confirming_account: "Confirming account",
    accounts_created: "Accounts created",
    of: 'of',
    or: "OR",
    search: "Search",
    clear: "Clear",
    status: "Status",
    actions: "Actions",
    add_new_user: "Add new user",
    edit_user: "Edit user",
    additional_emails: "Additional E-mails",
    organization_letterhead: "Organization Letterhead",
    similar_charities: "Similar Charities",
    similar_charities_description: "Search for charities similar to your organization this way we can find funders that support your area.",
    similar_charities_search_label: "Search charities",
    similar_charities_search_placeholder: "Type a charity name...",
    similar_charities_manual_entry_hint: "Can't find it in the list? Type the full name and press Enter to add it manually.",
    similar_charities_selected_count: "{{count}} selected",
    similar_charities_no_results: "No charities found",
    similar_charities_saved: "Similar charities saved successfully",
    add_similar_charities: "Add Similar Charities",
    company_information: "Organization Information",
    company_organization: "Organization",
    created_at: "Created at",
    added_by: "Added by",
    change_main_email: "Change main email address",
    main_email: "Main e-mail address",
    emails_created: "E-mails created",
    add_new_additional_email: "Add new additional e-mail",
    new_email_address: "New e-mail address",
    add_digital_letterhead: "Add digital letterhead",
    select_header_style: "Select letter style",
    header_only: "Header only",
    header_and_footer: "Header and Footer",
    exclude_pre_loaded:"Exclude Pre-Loaded",
    email_alert: "E-mail alert",
    signature: "Signature",
    user_letterhead: "User Letterhead",
    user_information: "User Information",
    position: "Position",
    enable_disable_notifications: "Enable / Disable notifications",
    user_name_or_email: "Username or email",
    avg_grants_Annually: "Average Grants Annually",
    avg_grant_size: "Average Grant Size",
    total_assets: "Total Assets",
    summary: "Summary",
    notes_taken: "Notes taken",
    last_report: "Last report",
    not_informed: "Not informed",
    loading_profile_summary: "Loading Profile Summary",
    amount: "Amount",
    grants: "Grants",
    funders: "Funders",
    funders_selected: "Funders Selected",
    show_grant_details: "Show grant details",
    profile_summary: "Profile Summary",
    view_profile: "View Profile",
    year: "Year",
    avg_grants: "Avg Grants",
    recipient: "Recipient",
    territories: "Territories",
    giving_int: {
      prefix: "National Giving Interest of",
      state: "State",
      province: "Province",
      territories: "Territories"
    },
    foundation_name: "Funder Name",
    import: "Import",
    organization_name: "Organization Name",
    contact_name: "Contact Name",
    state_or_province: "State / Province",
    info: "Info",
    add_funders_to_project: "Add Funders to Project",
    add_funder_to_project: "Add Funder to Project",
    export_to_excel: "Export to Excel",
    block_funders: "Block Funders",
    province: "Province",
    databases: "Databases",
    search_result: 'Search Result',
    back_to_search: 'Back to Search',
    year: "Year",
    amount: "Amount",
    location: "Location",
    purpose: "Purpose",
    recipient: "Recipient",
    category: "Category",
    sector: "Sector",
    sectors: "Sectors",
    not_provided_by: "Not provided by",
    keyword: "Keyword",
    my_list: "My List",
    shared_list: "Shared List",
    favorite_name: "Favorite Name",
    select_favorite: "Select a Favorite",
    close: "Close",
    confirm: "Confirm",
    description: "Description",
    show_saved_search: "Show saved search",
    save_regional_search: "Save Regional Search",
    save_search:"Save Search",
    switch_to_classic: "Switch To Classic",
    load_selected_saved_search: "Load Selected Saved Search",
    rename: "Rename",
    remove_save_search: "Remove saved search",
    updated_at: "Updated at",
    recipient: "Recipient",
    year: "Year",
    amt: "AMT",
    create_user_account: "Create User Project",
    edit_user_account: "Edit User Project",
    name_project: "Name of Project",
    total_project_cost: "Total Project Cost",
    start_date: "Start Date",
    end_date: "End Date",
    delete_project: "Delete Project",
    select_director_from_list: "Select director from the list",
    enter_custom_director: "Can't find a director? Enter a custom one instead",
    enter_director_name: "Enter Director's Name",
    select_director: "Select Director",
    enter_director_name: "Enter Director's Name",
    salutation: "Salutation",
    ask_amount: "Ask Amount",
    total_amount: "Total Amount",
    application_information: "Application Information",
    instruction: "Instructions",
    restriction: "Restrictions",
    deadline: "Deadline",
    contact: "Contact",
    delete_project: "Delete Project",
    largest: "Largest",
    average: "Average",
    median: "Median",
    search_result: 'Search Result',
    remove_funder: "Remove Funders",
    foundation_exists_other_projects: "This funder exists in other projects within your organization",
    remove_foundations_other_projects: "Remove funders from other projects",
    application_info: "Submission Guidelines",
    average: "Average",
    median: "Median",
    largest: "Largest",
    this_action_will_remove: "This action will remove",
    from_this_project: "from this project",
    hide_customized_funders: "Hide customized funders",
    project_funders: "Project Funders",
    custom_letter: "Custom Letter",
    change_project: "Change Project",
    return_grant_secretary: "Return to Grant Secretary",
    impact_report_letter: "Impact Report Letter",
    project_funders_master_document: "Project Funders / Master Document",
    master_document: "Master Document",
    letter_of_inquiry: "Letter of Inquiry",
    proposal: "Proposal",
    thank_you_letter: "Thank you letter",
    custom_document: "Custom Document",
    qualify: "Qualify",
    favorites: "Favorites",
    favorite_funders: "Favorite Funders",
    close: "Close",
    add_funders_to_project: "Add Funders to Project",
    add_funder_to_project: "Add Funder to Project",    
    select_one_or_more_projects: "Select one or more projects",
    block_funders: "Block Funders",
    print_funder_page: "Print Funder Page",
    move_to_previous_funder: "Move to the previous Funder",
    move_to_next_funder: "Move to the next Funder",
    remove_this_funder_from_qualified: "Remove this funder from qualified status and exclude from the favorite list.",
    mark_funder_as_qualified: "Mark this funder as qualified.",
    block_funder: "Block Funder",
    export_funders_to_excel: "Export funders to Excel",
    funder_name: "Funder Name",
    prev: "Prev.",
    next: "Next",
    previous: "Previous",
    visit_website: "Visit Website",
    notes: "Notes",
    add_note: "Add Note",
    company: "Company",
    email: "Email",
    website: "Website",
    contact_infos: "Contact Informations",
    other_infos: "Other Informations",
    help_center: "Help Center",
    profile_settings: "Profile Settings",
    hi: "Hi",
    user_profile: "User Profile",
    logout: "Logout",
    causes: "Causes",
    location_of_donations: "Location of Donations",
    reset_funder_qualification_status: "Reset a funder's qualification status",
    pause_qualification: "Paused Qualification",
    pause_qualification_process: "Pause qualification process without finalizing the decision.",
    reset_funder: "Reset Funder",
    qualified: "Qualified",
    paused_qualification: "Paused Qualification",
    unqualified: "Unqualified",
    return_to_gs_from: "Return to Grant Secretary from {{docType}}",
    referral: 'Refer a Charity & Earn Bonus Time!',
    referralFormPopup: "Refer a friend to win subscription time",
    referralShareFormPopup: "Share your referral link to win subscription time",
    referral_code_tooltip: "Click to copy referral code",
    phone_number: "Phone Number",
    email_address: "E-mail",
    charity_name: "Name of Charity",
    contact_name: "Name of Contact",
    referral_popup_title: "Refer a friend",
    logout:"Logout",
    flagged_donor_advised :"Flagged as Donor-Advised Fund",
    DAF: "DAF",
    referral_code:"Referral Code",
    report_grant: "Report a Grant",
    name_of_contact: "Name of Contact",
    grant_amount: "Grant Amount",
    date_awarded: "Date Awarded",
    earn_bonus_time: "EARN BONUS TIME!",
    additional_information:"Additional Information",
    categories:"Categories",
    populations_served:"Populations Served",
    mission:"Mission",
    geographic_areas_served: "Geographic Areas Served",
    org_profile: "Org. Profile",
    un_sdg_goals:"UN SDG Goals",
    social_media:"Social Media",
    select_goals:"Select Goals",
    no_goals_selected:"No Goals Selected",
    select_social_media:"Select Social Media",
    mission_placeholder:"What's your organization all about? Briefly share your main purpose or core mission here!",
    emails: "Emails",
    add_email: "Add Email",
    enter_new_email: "Enter new email address",
    adding_new_email: "Adding new email",
    target_beneficiaries: "Target Beneficiaries",
    measurable_outcomes: "Measurable Outcomes",
    type_keyword_and_press_enter: "Type a keyword and press Enter to add a tag",
    tags: "Tags",
    project_name_and_description: "Project Name and Description",
    project_date_and_cost: "Project Date and Cost",
    grant_advance_ai: "Grant Advance A.I",
    create_new_project: "Create New Project",
    edit_project: "Edit Project",
    other_information: "Other Information",
    header_and_footer_settings:"Header / Footer Settings",
    additional_information:"Additional Information",
    categories:"Categories",
    populations_served:"Populations Served",
    mission:"Mission",
    geographic_areas_served: "Geographic Areas Served",
    org_profile: "Org. Profile",
    un_sdg_goals:"UN SDG Goals",
    social_media:"Social Media",
    select_goals:"Select Goals",
    no_goals_selected:"No Goals Selected",
    select_social_media:"Select Social Media",
    mission_placeholder:"What's your organization all about? Briefly share your main purpose or core mission here!",
    exclude_header_footer: "Exclude organization header and footer",
    exclude_header_footer_desc: "When checked, the header and footer from the organization profile will not be loaded into the document preview. This is ideal if the header and footer are already included directly on your letterhead or Master Document.",
    settings_saved_successfully: "Settings saved successfully",
    add_header_footer: "This will apply the header and footer you uploaded in your Account Settings to the top and bottom of the first page of your document.",
    do_not_add_header_footer: "No header or footer will be applied to your document. We recommend this option when you are printing your documents on your pre-branded stationery or stationery that already has a letterhead.",
    other_information: "Other Information",
    header_and_footer_settings:"Header / Footer Settings",
    account_registration: "Account Registration",
    organization_info: "Organization Information",
    billing_info: "Billing Information",
    plan_selection: "Plan Selection",
    payment_info: "Payment Information",
    add_user_info: "Add your user information",
    add_organization_info: "Add your organization information",
    add_billing_info: "Add your billing information",
    select_plan: "Select a plan for your account",
    add_payment_info: "Add your payment information",
    organization_address: "Organization Address",
    address_line_2: "Address Line 2",
    postal: "Postal Code",
    zip: "Zip Code",
    same_billing_address: "Is your billing address the same as your organization's address?",
    billing_address: "Billing Address",
    select_payment: "Select your payment type",
    organization_name: "Organization Name",
    province: "Province",
    header_and_footer_settings:"Header / Footer Settings",
    save_regional_search: "Save Regional Search",
    save_search:"Save Search",
    switch_to_classic: "Switch To Classic",
    add_header_footer: "This will apply the header and footer you uploaded in your Account Settings to the top and bottom of the first page of your document.",
    do_not_add_header_footer: "No header or footer will be applied to your document. We recommend this option when you are printing your documents on your pre-branded stationery or stationery that already has a letterhead.",
    assets: "Assets",
    revenue: "Revenue",
    donations: "Donations",
    create_new_project_to_get_started: "Create new project to get started",
    be_sure_create_project_dg: "Be sure to create a project before using the Document Generator.",
    remove_duplicate_funders: "Remove Duplicate Funders",
    remove_funders_present_in_other_projects: "Remove Funders from this project present in other projects",
    bulk_flag_update: "Bulk Flag Update",
    print_return_labels: "Print Return Labels",
    print_labels: "Print Labels",
    labels: "Labels",
    print_selected: "Print {{text}}",
    preview_selected: "Preview {{text}} Documents",
    export_all_pdf_words_selected: "Export All {{text}} (PDF, Word)",
    documents: "Documents",
    export_to_excel: "Export to Excel",
    remove_from_this_project: "Remove from this project",
    notifications: "Notifications",
    feedback: "Feedback",
    giving_history: "Giving History",
    name: "Name",
    director: "Director",
    custom: "Custom",
    international_funding: "International Funding",
    director_name: "Director Name",
    from_country: "From Country",
    to_country: "To Country",
    county: "County",
    sub_sector: "Sub-sector",
    national_giving_interest: "National Giving Interest",
    min_grants_to_state: "Grants to State",
    min_grants_to_state_any: "Any # of grants",
    years: "Years",
    filter: "Filter",
    geographic_filters: "Geographic Filters",
    grant_filters: "Grant Filters",
    grant_size: "Grant Size",
    asset_size: "Asset Size",
    year_of_donation: "Year of Donation",
    keywords: "Keywords",
    any_of_these_words: "Any of these words",
    all_these_words: "All these words",
    none_of_these_words: "None of these words",
    stemming: "Stemming",
    thesaurus: "Thesaurus",
    cross_reference_search: "Cross Reference Search",
    add_cross_reference_search: "Add Cross Reference Search",
    state_filter: "State Filter",
    province_filter: "Province Filter",
    county_filter: "County Filter",
    city_filter: "City Filter",
    funder_characteristics: "Funder Characteristics",
    has_online_application: "Has Online Application",
    does_not_have_website: "Does Not Have Website",
    does_have_website: "Does Have Website",
    has_submission_guidelines: "Has Submission Guidelines",
    has_phone_number: "Has Phone Number",
    has_email: "Has Email",
    show_designated_giving: "Show Designated Giving",
    show_funders_without_donations: "Show Funders Without Donations",
    show_more: "Show more",
    search_history: "Search History",
    last_modified_on: "Last Modified on",
    saved_searches: "Saved Searches",
    saved_search: "Saved Search",
    saved_regional_search: "Saved Regional Search",
    history: "History",
    created_by: "Created by",
    choose_years: "Choose Years",
    databases: "Databases",
    cross_ref_on: "Cross Reference On",
    search_summary_all: "Search summary for all",
    active_filters: "Active Filters",
    group_by_funder: "Group by Funder",
    grant_summary: "Grant Summary",
    median_grant: "Median Grant",
    average_grant: "Average Grant",
    search_result: 'Search Result',
    view_saved_search: "View Saved Search",
    state_or_province: "State / Province",
    manage_coupons: "Manage coupons",
    create_new_coupon: "Create new Coupon",
    recipient_name: "Giving History",
    grant_purpose: "Grant Purpose",
    search_by_recipient_name: "Search by Recipient Name",
    search_by_grant_purpose: "Search by Grant Purpose",
    search_by_funder_name: "Search by Funder Name",
    type: "Type",
    discount: "Discount",
    tax: "Tax",
    extra_time: "Extra Time",
    expires_on: "Expires on",
    email_login: "Email Login",
    reenter_password: "Re-enter Password",
    no_plan_selected: "No Plan Selected",
    subscription_summary: "Subscription Summary",
    business_number: "Business Number",
    title: "Title",
    createdDate: "Created Date",
    createdBy: "Created By",
    notified: "Notified",
    notification: "Notification",
    emailNotificationDate: "Email Notification Date",
    editNote: "Edit note",
    removeNote: "Remove note",
    editAlert: "Edit alert",
    removeAlert: "Remove alert",
    updateAlert: "Update Alert",
    enterTitle: "Enter title",
    selectEmail:"Select email",
    notes_by: "Notes by",
    selectStatusFlag: "Select Flag Status",
    documentType: "Document Type",
    flagStatus: "Flag Status",
    submissionMethod: "Submission Method",
    flagDate: "Flag date",
    remove: "Remove",
    funderStatus: "Funder Status",
    create_project: "Create Project",
    remove_project: "Remove Project",
    unarchive: "Unarchive",
    archive_project: "Archive Project",
    mark_project_as_completed: "Mark project as completed",
    activate_project: "Activate project",
    activate_project_button: "Activate Project",
    no_projects_yet_heading: "You don't have any projects yet",
    search_manually: "Search Manually",
    start_qualifying_funders: "Start Qualifying",
    continue_qualifying_funders: "Continue Qualifying",
    view_funders: "View Funders",
    add_funders_to_project: "Add funders to this project",
    keep_looking_for_funders: "Keep looking for funders",
    use_your_peer_network: "Use your peer network",
    peer_search: "Peer Search",
    run_peer_search: "Run Peer Search",
    about_qualifying_funders: "About qualifying funders",
    about_peer_search: "About Peer Search",
    project_overview_title: "{{name}} Overview",
    project_name: "Project Name",
    shared_by: "Shared By",
    project_status: "Project Status",
    notified_at: "Notified at",
    notify_at: "Notify at",
    updating_notes: "Updating notes",
    attached_documents: "Attached Documents",
    alert_notification: "Alert Notification",
    notification_sent: "Notification Sent",
    notification_by_email: "Notification by Email",
    attach_documents: "Attach Documents",
    loading_attached_documents: "Loading Attached Documents",
    search_by_year_searchbar_title: "By Year Founded",
    search_by_name_searchbar_title: "By Funder Name",
    search_by_director_searchbar_title: "By Board Directors",
    search_by_custom_searchbar_title: "By Private Contacts",
    search_by_keyword_searchbar_title: "By Giving Interest",
    create_coupon: "Create Coupon",
    update_coupon: "Update Coupon",
    code: "Code",
    expiration_date: "Expiration Date",
    toggle_to_extra_time: "Toggle to Extra Time",
    toggle_to_discount: "Toggle to Discount",
    extra_month: "Extra Month",
    discount_percentage: "Discount Percentage",
    coupon_default_flag: "Coupon Default Flag",
    unlock_plans: "Unlock Plans",
    template_coupon: "Template Coupons",
    search_by_giving_history_searchbar_title: "By Giving History",
    demo_access_link: "Demo access link",
    signed_in_as: "Signed in as",
    for_sales_use_only: "For internal use only",
    your_access_link: "Your access link",
    expires_in: "Expires in",
    link_becomes_invalid: "link becomes invalid after that",
    email_reminders: "Email Reminders",
    file_attachments: "File Attachments",
    add_notification: "Add Notification",
    add_email_notification: "Add Email Notification",
    edit_email_notification: "Edit Email Notification",
    select_date: "Select Date",
    notifications_found: "Notifications Found",
    switch_to_new: "Switch to new",
    switch_to_legacy: "Switch to legacy version",
    has_application_description: "Has Application Description",
    giving_interest: "Giving Interest",
    board_directors: "Board Directors",
    year_founded: "Year Founded",
    private_contacts: "Private Contacts",
    welcome_back_2: "Welcome Back",
    email_address_2: "Email Address",
    recently_saved_search: "Recently Saved Search",
    edit_notification: "Edit Notification",
    licenses: "Licenses",
    registered: "Registered",
    status: "Status",
    role: "Role",
    delete: "Delete",
    suspend_license: "Suspend License",
    licenses_used: "licenses used",
    available: "Available",
    new_main_user: "New main user",
    previous_main_user: "Previous main user",
    will_be_downgraded_part: "will be downgraded to a subuser with the",
    supervisor: "Supervisor",
    main_user: "Main user",
    not_applied: "Not applied",
    disabled: "Disabled",
    active: "Active",
    expired: "Expired",
    deleted: "Deleted",
    trial: "Trial",
    trial_expired: "Trial Expired",
    upgrade_demo_account: "Upgrade Demo Account",
    account_email: "Account email",
    pipedrive: "Pipedrive",
    number_of_licenses: "Number of Licenses",
    payment: "Payment",
    pay_now: "Pay Now",
    paid: "Paid",
    payment_method: "Payment Method",
    send_payment_link: "Send Payment Link",
    skip_payment: "Skip Payment",
    search_by: "Search by",
    no_data_to_display: "No data to display",
    qualified_funder: "Qualified Funder",
    qualifications: "Qualifications",
    grant_type: "Grant Type",
    qualified_by: "Qualified By",
    date_added: "Date Added",
    internal_notes: "Internal Notes",
    funder_qualification: "Funder Qualification",
    edit_funder_qualification: "Edit Funder Qualification",
    qualify_funders: "Qualify Funder(s)",
    create_add_to_favorite_list: "Create/Add to Favorite List",
    enter_rationale_or_notes: "Enter rationale or notes",
    delete_qualification: "Delete Qualification",
    type_a_sector_name: "Type a sector name",
    this_field_is_empty: "The field is empty",
    adding_sector: "Adding sector",
    adding_grant_type: "Adding grant type",
    choose_grant_type_or_create_one: "Choose a grant type or create one",
    other_funding_source: "Other Funding Source",
    statistical_proof: "Statistical Proof",
    do_it_with_grant_advance_ai: "Do it with Grant Advance AI",
    find_matching_funders: "Find matching funders",
    find_funders_with_ai: "Find funders with AI",
    ai_beta_badge_label: "About AI beta status",
    draft_your_letter_of_inquiry: "Draft your letter of inquiry",
    write_loi_with_ai: "Write LOI with AI",
    generate_full_content: "Generate full content",
    generate_step_content: "Generate with AI",
    regenerate_step_content: "Regenerate with AI",
    reviewed: "Reviewed",
    mark_as_reviewed: "Mark As Reviewed",
    change_tone: "Change Tone",
    change_content_tone: "Change Content Tone",
    save_and_work_on_later: "Save and work on later",
    generate_full_content_with_ai: "Generate full content with AI",
    select_tone: "Select Tone",
    select_reason: "Select Reason",
    reason_donation: "Thank you for your donation",
    reason_rejected: "Thank you for considering (Rejected)",
    reason_no_reply: "Thank you for considering (No Reply)",
    reason_other: "Other",
    other_reason_placeholder: "Describe the reason for this letter",
    generate: "Generate",
    overwrite_content: "Overwrite Content",
    entire_country: "Entire country",
    everywhere_within_one_country: "Everywhere within one country",
    specific_area: "Specific area",
    a_region_a_city_or_both: "A {{orgRegion}}, a city, or both",
    select_a_country: "Select a country",
    all_states: "All states",
    all_provinces: "All provinces",
    all_cities: "All cities",
    all_counties: "All counties",
    add_area: "Add area",
    add_charity: "Add charity",
    add_statistical_proof: "Add statistical proof",
    search_more_suggestions: "Search for more suggestions",
    add_your_own_statistical_proof: "Add your own statistical proof",
    statistical_proofs_added: "Added statistical proofs",
    view_source: "View source",
    areas_added: "Areas added",
    go_to_fields: "Go to fields",
    add_stat: "Add stat",
    generate_suggestions: "Generate Suggestions",
    on: "On",
    off: "Off",
    quick_qualification: "Quick Qualification",
    already_qualified: "Already qualified",
    qualifying_preferences_uppercase: "QUALIFYING PREFERENCES",
    carry_forward_selection: "Carry forward selection",
    keeps_your_project_picks_selected: "Keeps your project picks selected for the next funder",
    auto_advance_next_funder: "Auto-advance to next funder",
    not_fit: "Not Fit",
    add_to_project: "Add to Project",
    qualify_funder: "Qualify Funder",
    add_details: "Add details",
    add_details_helper_collapsed: "Sector, grant type, notes — optional",
    add_details_helper_expanded: "Optional",
    pick_a_verdict_to_continue: "Pick a verdict to continue",
    marked_qualified: "Marked Qualified",
    marked_not_fit: "Marked Not Fit",
    select_funder: "Select funder",
    previous_funder: "Previous funder",
    next_funder: "Next funder",
    reopen_quick_qualification: "Reopen Quick Qualification",
    qualification_verdict: "Qualification verdict",
    funder_revoked: "Funder Revoked",
    new_donees: "New Donees",
    already_applied: "Already Applied",
    view_projects: "View projects",
    do_not_contact: "Do Not Contact",
    funded: "Funded",
    previously_declined: "Previously Declined",
    returned_to_sender: "Returned to Sender",
    added_to_a_project: "Added to a Project",
    added_on_date: "Added {{date}}",
    flag_status_added: "Added",
    flag_status_submitted: "Submitted",
    flag_status_approved: "Approved",
    flag_status_declined: "Declined",
    flag_status_no_response: "No Response",
    flag_status_awarded: "Awarded",
    flag_status_proposal_requested: "Proposal Requested",
    flag_status_declined_do_not_contact: "Do Not Contact",
    flag_status_inquiry_submitted: "Inquiry Submitted",
    flag_status_proposal_submitted: "Proposal Submitted",
    flag_status_thankyou_submitted: "Thank You Submitted",
    flag_status_impact_report_submitted: "Impact Report Submitted",
    flag_status_custom_letter_submitted: "Custom Letter Submitted",
    flag_status_inquiry_declined: "Inquiry Declined",
    flag_status_proposal_declined: "Proposal Declined",
    flag_status_return_to_sender: "Return to Sender",
    coupon_code: "Coupon Code",
    sector_subsector: "Sector / Sub-sector",
    start_day: "Start Day",
    save_options: "Save Options",
    province_plus_one: "Province+",
    province_plus_other: "Provinces+",
    state_plus_one: "State+",
    state_plus_other: "States+",
    funders_matched: "Funders Matched",
    directors_matched: "Directors Matched",
    total_directors: "Total Directors",
    change_ownership: "Change Ownership",
    current_owner: "Current Owner",
    created: "Created",
    last_login: "Last Login",
    new_owner: "New Owner",
    sales_account: "Sales Account",
    confirm_changes: "Confirm Changes",
    roles: "Role(s)",
    created_by: "Created By",
    account_information: "Account Information",
    transfer_ownership: "Transfer Ownership",
    delete_account_exclamation: "Delete Account?",
    delete_account: "Delete Account",
    reset_fields: "Reset Fields",
    map_now: "Map now",
  },
  crossReference: {
    any_of_these_words: "Any of These words",
  },
  filters: {
    no_low_limit: "No low limit",
    no_upper_limit: "No upper limit",
  },
  errors: {
    model_error: 'Check for errors and try again',
    general_error: 'An error has occurred',
    profile_still_loading: 'Your profile is still loading. Please wait a moment and try again.',
    organization_info_incomplete: 'Please complete all required fields in Organization Information before continuing.',
    invalid_token: 'Invalid token',
    confirming_account_error: "This link has expired. Would you like us to send you a new activation/setup email?",
    invalid_image: "Invalid image",
    inform_crop_area: "Size Image to conform to required dimensions",
    funder_not_found: "Funder not found",
    file_list_error: "File list error",
    funder_not_found: "Funder not found",
    select_at_least_one_funder: "Please select at least one funder before continue",
    select_one_or_more_funders_delete: "Select one or more funders to delete",
    select_one_or_more_funders_block: "Select one or more funders to block",
    this_link_has_expired: "This link has expired.",
    would_you_like_us_to_send_email: "Would you like us to send you a new activation/setup email?",
    recaptcha_failed: "Security verification failed. Please try again by clicking Next.",
    recaptcha_required: "Security verification is required.",
    both_password_must_be_the_same: "Both password must be the same",
    error_creating_token: "Error creating token",
    select_new_owner: "Select the new owner"
  },
  success: {
    logout_success: 'User logout successfully',
    copied_to_cliboard: 'Copied to clipboard',
    organization_update: 'Organization information updated successfully',
  },
  messages: {
    jumpstart_journey: "Dear {userName}, Jumpstart your journey with these insightful slides to navigate our site, find potential funders, and craft grant applications.",
    have_questions: "Have questions? Join our interactive webinar for real-time support. Reserve your spot by clicking the link here.",
    follow_guide: "Follow the attached guide for proven strategies to secure grant funding.",
    referral_bonus_1: "When the first charity you refer signs up with Grant Advance, you'll receive one bonus month.",
    referral_bonus_2: "The second referral earns you two bonus months.",
    referral_bonus_3: "The third and any additional referrals earn you three bonus months each.",
    report_grant_bonus_1: "Additional user licenses for your team",
    report_grant_bonus_2: "Letter of Inquiry writing services",
    report_grant_bonus_3: "Membership subscriptions & renewals",
    it_takes_less_than_a_minute: "It takes less than a minute, and your credits are waiting. Credits have no cash value and cannot be combined with other offers.",
    password_recovery_message: "To have a new password sent to you enter the username and email address you used to register",
    inform_new_password_message: "Please enter your new password",
    setting_up_account_message: "To activate your account, please enter the password and confirm",
    confirming_account_wait: "Please wait while we confirm your account",
    first_letterhead_message: "- Letterhead should be approximately 700 x 200 px.",
    second_letterhead_message: "- Supported formats are .GIF, .png, .jpeg and .jpg.",
    third_letterhead_message: "- Your organization's letterhead will appear at the top of all documents.",
    check_organization_settings_message: "Please check your organization profile letterhead settings or contact support.",
    funders_not_selected_message: 'Please select at least one funder before continuing',
    project_not_selected_message: "Please create or select a project first", 
    project_not_selected_message: "Please create or select a project first",
    you_must_select_state: "You must select a State to enable the City filter.",
    deselect_all_counties: "Deselect all counties to enable the City filter.",
    select_one_favorite_list: 'Please select at least one favorite list or create a new one',
    create_new_favorite_list: "Create new Favorite List",
    add_funders_favorite_list: "Add Funder(s) to Favorites",
    saved_search_load_successfully: "Saved search loaded successfully",
    save_search: "Save Search",
    delete_project: "Are you sure you want to delete this project?",
    check_organization_settings_message: "Please check your organization profile letterhead settings or contact support.",
    funders_not_selected_message: 'Please select at least one funder before continuing',
    are_you_sure: "Are you sure?",
    this_action_will_remove_document_funder: "This action will remove the document for this funder",
    this_action_will_remove_master_document: "This action will remove this Master Document",
    want_to_remove_the_funder: "Do you want to remove the funder from this list?",
    this_will_remove_customized_documents: "This will remove {{documents}} customized document(s) and return the funder to the Master List. To remove funders(s) permanently delete them from the Master List.",
    remove_the_funders_from_the_projects: "Removes the Funders from the projects you selected from the current project.",
    select_in_dropdown_example: "e.g. If you select a project in the dropown and it has 3 funders, 'a', 'b' and 'c' and the project you are working on also has 'a', 'b', 'c', these will be removed from the working project.",
    this_will_remove_funders_from_this_project: "This action will remove {{funders}} funder(s) from this project.",
    want_reset_this_funder: "Are you sure you want to reset this funder?",
    do_not_insert_pre_loaded_letterhead_or_footer_document:"Do not insert pre-loaded letterhead or footer from your Organization Profile in generated documents",
    new_email_has_been_send: "A new email has been sent to your address.",
    stop_working_with_fragmented_views:"Stop Working with Fragmented Views.",
    gain_unified_donor_intelligence: "Gain Unified Donor Intelligence & Craft Proposals That Truly Hit Home.",
    unlock_full_access_become_a_member: "Unlock full access: Become a member.",
    see_how_it_works_schedule_a_free_tour:"See how it works: Schedule a free tour.",
    just_a_reminder:"Just a reminder: Your",
    discount_will_expire:"discount will expire on",
    un_sdg_goals:"Making an impact? The UN SDGs are global goals for a better future (like 'Zero Hunger' or 'Climate Action').",
    social_media:"Got social media? Add the links to your profiles (like Instagram, Facebook, X, LinkedIn) right here!",
    categories:"Select the categories that best describe your organization's mission or focus areas.",
    geographic_areas_served:"Specify the geographic regions where your organization provides services or support.",
    populations_served:"Indicate the primary groups or communities your organization serves",
    mission:"What's your organization all about? Briefly share your main purpose or core mission here!",
    be_sure_creating_project_before_using_search_engine:"Be sure to create the project before using the search engine.",
    assets_tooltip: "Total assets reported at the end of the year, as listed in the IRS Form 990 series",
    revenue_tooltip: "Total annual revenue recorded in the IRS Form 990 series",
    donations_tooltip: "Total contributions made during the year, based on the IRS Form 990 series",
    charities_helping_charities: "Charities Helping Charities Referral Program",
    refer_charity_earn_bonus: "Refer a charity & Earn Bonus time!",
    refer_charity_line1: "When the first charity you refer signs up with Grant Advance, you'll receive one bonus month.",
    refer_charity_line2: "The second referral earns you two bonus months.",
    refer_charity_line3: "The third and any additional referrals earn you three bonus months each.",
    heads_up_irs_check_profile: "Heads up! The IRS doesn't provide attachments in the electronic data we use here. But sometimes, you'll find those attachments in the PDF version of the filing—check the profile!",
    heads_up_irs_check_below: "Heads up! The IRS doesn't provide attachments in the electronic data we use here. But sometimes, you'll find those attachments in the PDF version of the filing—check below!",
    remove_from_this_project: "Removes selected funders from the current project if they already exist in the chosen projects, helping prevent duplicates.",
    delete_selected_custom_document: "This action will delete the custom document for the selected funders.",
    delete_single_custom_document: "This action will delete the custom document for this funder",
    recaptcha_loading: "Please wait while security verification loads...",
    consent_to_allowing: "I consent to allowing Grant Advance share this good news on their website, social media, and other platforms",
    type_keyword: "Type a keyword and press Enter to add a tag",
    add_alternatives_to_root_word: "Add alternatives to the root word(s) in your search",
    view_and_manage_searches: "View and manage your saved search result & selected filter information for future reference",
    load_saved_search: "Load Saved Search",
    load_saved_search_description: "Loading the saved search will reset your current search result & filter information to the saved search you selected.",
    switch_search_type: "Switch Search Type",
    switch_search_type_description: "Switching the search type will clear the filters you've applied here. Continue?",
    no_saved_search: "No Saved Search",
    coupon_textfield_placeholder: "Search by coupon code, name, or created by",
    no_results_found: "No results found",
    no_results_found_2: "No results found, try a different keyword.",
    go_to_search_page: "Go To Search Page",
    searching_for_funders: "Searching for funders",
    kindly_ensure_template_personalized: "Kindly ensure the template is personalized to reflect your own voice and message. We don't recommend copying and pasting the letter directly. Since it's accessible to all our members, it's best used as inspiration to create your own unique version.",
    i_understand_deleting_this_master: "I understand that deleting this master document will permanently delete",
    customized_documents: "customized documents",
    action_cannot_be_undone: "and this action cannot be undone",
    select_notification_date: "Select the date you would like to be notified",
    delete_this_alert: "Would you like to delete this alert",
    delete_this_note: "Would you like to delete this note",
    update_funders_flag_status: "This action will update the Funder's flag status",
    set_project_as_completed: "Set the project {{projectName}} as Completed?",
    activate_project_confirm: "Activate '{{projectName}}'? This will mark it active and move the current active project back to In Progress.",
    no_similar_charities_title: "Add Similar Charities First",
    no_similar_charities_confirm: "This project doesn't have any similar charities yet. Add some to run a Peer Search.",
    no_projects_yet_description: "Create a project to start matching funders and generating grant documents.",
    no_funders_in_project: "There are no funders in your Project",
    funders_currently_in_project_singular: "{{count}} funder currently in your Project",
    funders_currently_in_project_plural: "{{count}} funders currently in your Project",
    qualified_funders_progress: "{{qualifiedCount}} of {{fundersAmount}} qualified",    peer_search_info: "This will use the list of similar charities to search for funders that have supported them.",
    qualifying_info: "Qualifying is where you review each funder in this project and mark whether they are a genuine fit — eligibility, giving priorities and deadlines — before you write to them.",
    created_on_date: "Created On: {{createdAt}}",
    ai_draft_recommended: "AI can generate a strong first draft of this document for you to review and customize.",
    ai_beta_badge_tooltip: "This AI feature is in beta. Results may be incomplete or inaccurate, so please review them before relying on them.",
    manual_draft_recommended: "This document is best written manually.",
    status_flag_for: "Status flag for {{foundationName}}",
    upload_document: "Upload any kind of documents no larger than {{fileSize}} MB",
    upload_document_up_to: "Upload up to {{fileCount}} files at a time, with a maximum size of {{fileSize}} MB each. Supported file types: All files",
    this_action_will_delete: "This action will delete {{name}}",
    your_session_has_expired: "Your session has expired. Please sign in again",
    your_account_without_permission: "Your account doesn’t have the required permissions for this action.",
    congratulations_on_securing_funding: "Congratulations on securing funding! Now make that win work twice. Report your grants and receive 25 Bonus Credits ($25 value) for each — redeemable for services that help your organization do even more:",
    select_one_or_more_subscription_plans: "Select one or more Subscription Plans",
    action_50percent_discount: "This action will give this coupon a discount of more than 50%",
    token_copied_to_clipboard: "Token copied to clipboard",
    open_this_link_in_a_separated_browser: "Open this link in a separate browser or incognito window to tour the platform as this demo account. Use it during prospect calls to walk through features without needing a password.",
    do_not_share_with_customers: "Do not share with customers· Open in a separate browser or incognito window",
    resend_funder_alert_notifications: "Re-send funder alert notifications",
    notifications_send_sucessfully: "{{count}} notification(s) sent successfully",
    notifications_found: "Notifications Found",
    enter_your_account_details: "Enter your account details below to log in",
    having_trouble_signing_in: "Having trouble signing in",
    you_can_reset_password_here: "You can reset your password here",
    kindly_enter_email_address: "Kindly enter the email address you used to sign up. We will send you a link to reset your password.",
    kindly_enter_new_password: "Kindly enter your new password",
    password_must_contain: "Password must contain",
    password_length_requirement: "At least 8 characters",
    password_uppercase_requirement: "At least one uppercase letter (A–Z)",
    password_lowercase_requirement: "At least one lowercase letter (a–z)",
    password_number_requirement: "At least one number (0–9)",
    password_special_character_requirement: "At least one special character (!@#$%^&* etc.)",
    notifications_found: "Notifications Found",
    the_user_will_lose_access: "The user will lose access until the license is activated",
    suspend_the_license: "Suspend this License?",
    user_will_remain_active: "User access will remain active during license activation",
    active_the_license: "Active this license?",
    activate_license: "Activate License",
    change_to_main_user: "Change to Main User",
    remove_this_license: "Remove this License?",
    you_are_about_to_remove_this_license: "You are about to remove this license",
    change_the_main_user: "Change the main user?",
    this_updates_the_organization_master_account: "This updates the organization's master account. The action is applied immediately.",
    remove_email_notification: "Remove Email Notification",
    are_you_sure_remove_alert: "Are you sure you want to remove this email notification?",
    opens_bambora_form: "Opens Bambora form - upgrade after approval",
    mark_as_paid: "Mark as Paid - upgrade directly",
    to_be_implemented: "To be implemented",
    upgrade_with_no_payment: "Upgrade with no payment",
    on_confirm_demo_data_message: "On confirm: demo data preserved, status reset (welcome dialog reappear), setup email sent.",
    delete_this_qualification: "Are you sure you want to delete this qualification?",
    funder_qualified_successfully: "Funder Qualified Successfully",
    last_qualified_for: "Last qualified for",
    press_enter_enter_to_add_grant_type: "Press enter to add grant type",
    find_or_create_grant_type: "Find or create grant type",
    press_enter_to_add_sector: "Press enter to add sector",
    find_or_create_sector: "Find or create sector",
    select_at_least_one_sector: "Select at least one sector",
    select_at_least_one_grant_type: "Select at least one grant type",
    ai_scan_database: "AI scans the database and ranks funders by fit with this project.",
    peer_search_no_ai: "Search funders through charities like yours — no AI involved.",
    generate_full_loi: "Generate a full LOI from your project details in about a minute.",
    grant_advance_ai_benefit: "This information powers Grant Advance AI — used to generate documents like Letters of Inquiry and Proposals, and to find funders that match your project's goals.",
    grant_advance_ai_active: "Grant Advance AI uses this information to generate documents like Letters of Inquiry and Proposals, and to find funders that match your project's goals.",
    required_fields_legend: "* Required fields",
    fill_in_name_and_description: "Fill in Name of Project and Description above, then generate AI suggestions.",
    ready_to_generate_ai_suggestions: "Ready to generate AI suggestions for Target Beneficiaries, Keywords, and Statistical Proof based on your project details.",
    statistical_proof_recommendation: "We recommend adding up to 2 statistical proofs, but you can add as many as you'd like.",
    no_statistical_proof_suggestions: "No suggestions available yet. Try searching for more.",
    some_steps_not_reviewed: "You have not reviewed contents generated by AI in the following step(s) of your Letter of Inquiry.",
    some_steps_not_completed: "It looks like some steps in this module aren't finished yet. Please continue only if you want to skip them.",
    review_with_ai_powered: "Do you want to review and customize this document using AI Powered?",
    ai_generated_content_please_review: "AI-generated content — please review, edit if necessary, and confirm.",
    overwrite_content_warning: "When enabled, generated content will replace all existing steps. When turned off, content is only generated for empty steps.",
    gas_description: "Add the places your organization works in. Choose an entire country, or a {{orgRegion}} or city within {{orgCountry}}.",
    specific_area_description: "Areas are listed for {{orgCountry}}. To serve another country, add it as an entire country.",
    saved_search_loaded_main: "Saved search loaded and applied",
    saved_search_loaded_result: "Saved search loaded and applied",
    are_you_sure_you_want_proceed: "Are you sure you want to proceed",
    review_with_ai: "Review with AI",
    to_create_personalize_ai_doc: "To create a more personalized AI document, Grant Advance recommends completing all the steps in your {{docType}}.",
    funder_inactive: "Funder inactive for 3+ years. No IRS activity reported.",
    this_funder_has_supported: "This funder has supported {{count}} new donees in the last 3 years.",
    you_have_an_existing_application: "You have an active application with this funder.",
    funder_asked_not_to_be_contacted: "This funder asked not to be contacted again.",
    you_have_received_funding: "You've received funding from this funder.",
    past_application_was_declined: "A past application to this funder was declined.",
    mail_was_returned_to_sender: "Mail sent to this funder was returned. Check the address before applying again.",
    funder_already_in_a_project: "This funder is already in a project in your organization.",
    ownership_will_be_transferred: "Ownership will be transferred to the selected sales account immediately.",
    change_the_owner_of_this_demo: "Change the owner of this demo account",
    this_account_was_removed: "This account was removed",
    the_selected_sales_associate_will_become_the_new_owner: "The selected sales associate will become the new owner of this demo account. Current ownership assignments will be updated immediately after confirmation.",
    are_you_sure_delete_demo_account: "Are you sure you want to delete this demo account? This action cannot be undone. All associated data, settings, and history will be permanently removed and will no longer be accessible.",
    geographic_areas_confirm_title: "Add your selected areas before continuing?",
    geographic_areas_confirm_description: "Your selections haven’t been added yet. “Add and continue” adds them for you without returning to the Add area button. Or continue without adding them.",
    geographic_areas_add_failed: "We couldn’t add your selected areas. Check your selections and try again.",
    geographic_areas_save_failed: "We couldn’t save your areas. Please try again.",
    unadded_geographic_areas: "You have unadded areas",
    unadded_geographic_areas_description: "Your selected areas aren’t on your list yet. Go back and click Add Area to keep them, or continue without them.",
    click_here_to_create_sector: "Click here to create a new sector",
    click_here_to_create_grant_type: "Click here to create a new grant type",
    fields_mapped: "{{amount}} of {{total}} fields mapped",
    require_fixing: "{{amount}} of {{total}} fields require fixing",
    fields_can_be_mapped: "Some headers closely match your fields. Map them automatically?",
    delete_information: "Delete {{name}} Information",
    remove_information: "Are you sure you want to remove this {{name}} Information?",
    importAnOrganizationDatabase: "Import an organization database",
    importAnIndividualDatabase: "Import an individual database",
    importOrganizationHelp: "Import a database of organizations with their contact details and locations.",
    importIndividualHelp: "Import a database of individuals with their contact details and positions.",
  },
  user_menu: {
    profile: 'Profile',
    logout: 'Logout'
  },
  prompt: {
    areYouSure: "Are you sure?",
    confirmRemove: "Confirm Remove",
  },
  side_menu: {
    administration: 'Administration',
    manage_account: 'Manage Account',
    manage_announcement: 'Announcement',
    manage_subscription_plan: 'Subscription Plan',
    manage_coupons: 'Coupons',
    manage_feedbacks: 'Feedbacks',
    manage_deadlines: 'Deadlines',
    manage_smart_phrases: 'Smart Phrases',
    manage_foundations: 'Manage Foundations',
    manage_plans: 'Manage Plans',
    account: 'Account',
    user_profile: 'User Profile',
    additional_users: 'Additional Users',
    organization_profile: 'Organization Profile',
    project_manager: 'Project Manager',
    project_list: 'Projects',
    project_archive: 'Archived Projects',
    search_engine: "Search Engine",
    search_engine_canada: "Search Engine - CA (beta)",
    by_giving_history: 'By Giving History',
    by_name: 'By Funder Name',
    by_director: 'By Board Directors',
    by_year: 'By Year Founded',
    by_deadline: 'By Deadline',
    by_rating: 'By Rating',
    by_custom: 'By Private Contacts',
    by_custom_profile: 'By Custom Profile (New)',
    document_generator: 'Document Generator',
    inquiry: 'Inquiry',
    proposal: 'Proposal',
    budget: 'Budget',
    custom_letter: 'Custom Letter',
    grant_secretary: 'Grant Secretary - Print',
    manage_funders: 'Manage Funders',
    favorites: 'Favorites',
    blocked_funders: 'Blocked',
    custom_databases: 'Custom Databases',
    by_keyword: 'By Giving Interest',
    by_international_funding: 'International Funding (PRO)',
    thank_you: 'Thank You',
    impact_report: 'Impact Report',
    previous: "Previous",
    by_recipient_name: "By Recipient Name",
    by_grant_purpose: "By Grant Purpose",
    by_funder_name: "By Funder Name",
  },
  buttons: {
    done: "Done",
    create_account: "Create account",
    send: "Send",
    reset_password: "Reset Password",
    add_user: "Add User",
    insert_user: "Insert User",
    save_changes: "Save Changes",
    update_profile: "Update Profile",
    add_to_favorites: "Add to Favorites",
    add_email: "Add E-mail",
    select_header_file: "Select header file",
    select_footer_file: "Select footer file",
    update_account: "Update Account",
    add_to_favorites: "Add to Favorites",
    more: "More",
    clear_search: "Clear Search",
    search: "Search",
    advanced_search: "Advanced Search",
    create: "Create",
    create_favorite_list: "Create Favorite List",
    add: "Add",
    confirm: "Confirm",
    update: "Update",
    confirm_delete: "Confirm Delete",
    confirm_remove: "Confirm Remove",
    next: "Next",
    prev: "Prev.",
    add_funder: "Add Funder",
    close: "Close",
    preview_document:"Preview document",
    submit: "Submit",
    cancel: "Cancel",
    resend_email: "Resend E-mail",
    confirm_purchase: "Confirm Purchase",
    previous: "Previous",
    watch_demo: "Watch demo",
    learn_more: "Learn More",
    filters: "Filters",
    apply_filters: "Apply Filters",
    clear_filters: "Clear Filters",
    select_states: "Select States",
    select_provinces: "Select Provinces",
    select_counties: "Select Counties",
    select_cities: "Select Cities",
    yes_load_search: "Yes, Load Search",
    no_keep_current_search: "No, Keep Current Search",
    yes_switch_search_type: "Yes, Switch",
    no_keep_current_filters: "No, Keep Filters",
    search: "Search",
    search_options: "Search Options",
    apply: "Apply",
    remove_flag: "Remove Flag",
    save: "Save",
    claim_my_credits: "Claim My Credits",
    more: "More",
    copy_and_close: "Copy & Close",
    send_notifications: "Send Notifications",
    try_again: "Try Again",
    forgot_password: "Forgot Password",
    no_keep_notification: "No, Keep Notification",
    yes_remove: "Yes, Remove",
    view_qualifications: "View Qualifications",
    add_new_qualification: "Add New Qualification",
    edit: "Edit",
    delete: "Delete",
    qualify_funder: "Qualify Funder",
    qualify_this_funder: "Qualify This Funder",
    add_qualification: "Add Qualification",
    yes_delete: "Yes, Delete",
    no_keep_qualification: "No, Keep Qualification",
    start_editing: "Start Editing",
    generate_with_ai: "Generate with AI",
    create_manually: "Create Manually",
    add_and_continue: "Add and continue",
    continue_without_adding: "Continue Without Adding",
    go_back: "Go Back",
    no_keep_information: "No, Keep Information",
  },
  input_fields: {
    press_enter: "Press Enter to add keywords",
  },
  tooltips: {
    to_country_filter: "Selecting one or more countries will disable the State Filter",
    state_filter: "Selecting one or more states will disable the Country Filter",
    county_filter: "Select a state to enable the county filter. Deselect all cities to enable county filter",
    city_filter: "Select a state to enable the city filter. Deselect all counties to enable city filter",
    custom_city_filter: "Select a state to enable the city filter",
    cross_ref_location: "With Cross-Reference Search on, the State, County, and City selected here are applied as extra filters alongside your Cross-Reference terms — a donation must go to this location (and still match your Country and Year filters) to count.",
    cross_ref_location_ca: "With Cross-Reference Search on, the Province and City selected here are applied as extra filters alongside your Cross-Reference terms — a donation must go to this location (and still match your Year and Sector filters) to count.",
    national_giving_interest_us_off: "Adds funders who match your search terms and have given in at least the selected number of states, even if they haven't given in your selected state.",
    national_giving_interest_us_on: "With Cross-Reference Search on, National Giving Interest lets funders who give across many locations still match even when the specific donation isn't in your selected state, county, or city, as long as it still matches your search terms, country, year, and the cross-reference term itself.",
    national_giving_interest_ca_off: "Adds funders who match your search terms and have given in at least the selected number of provinces, even if they haven't given in your selected province.",
    national_giving_interest_ca_on: "With Cross-Reference Search on, National Giving Interest lets funders who give across many locations still match even when the specific donation isn't in your selected province or city, as long as it still matches your search terms, year, sector, and the cross-reference term itself.",
    min_grants_to_state: "Minimum number of grants given to organizations in every selected state, across all available giving history.",
    business_ein: "Need to update your EIN/BN? Simply send an email to support@grantadvance.com with your correct information and our team will take care of it for you.",
    by_name: "Previously known as By Name",
    by_keyword: "Previously known as By Keyword",
    by_year: "Previously known as By Year",
    by_director: "Previously known as By Director",
    by_custom: "Previously known as Custom Database",
    target_beneficiaries: "Select the groups or individuals who will directly benefit from this project.",
    create_project_keyword: "Add relevant keywords to help categorize and improve discoverability of your project.",
    similar_charities: "Search for charities similar to this project so we can find funders that support your area.",
    other_funding_source: "Specify any additional funding sources contributing to this project beyond the primary grant.",
    statistical_proof: "Provide data or evidence that supports the need and projected impact of your project.",
    grant_advance_ai: "Our AI model uses your project details such as target beneficiaries, keywords, and statistical proof. You can also add custom information for these fields based on your preferences.",
    by_giving_history_info: "Search for the name of a charity to see a list of the foundations that fund it.",
    by_keyword_info: "Search by keywords to view funders that have donated to charities whose names or descriptions contain your terms (highlighted in results).",
    by_name_info: "Search for the full name of a funder or related keywords to see a list of profiles that match your terms.",
    by_director_info: "Search for the name of a director to find the funders they are affiliated with, and consult their profiles to view the charities they support.",
    by_year_info: "Select one or more years to view the funders that provided contributions during those years, and consult their profiles to see the charities they supported.",
    by_custom_info: "Use custom search to filter results based on your own database",
    by_international_info: "Search across our global databases to find foundations operating beyond your country’s borders.",
  },
  accountCreated: "Account created successfully",
  accountDisabled: "This account is disabled. For more details contact the administrator.",
  accountDisabledSuccess: "Account disabled successfully",
  accountEnabledSuccess: "Account enabled successfully",
  accountNotActivated: "Your account is not active. Please check your email to activate your account",
  accountUpdatedSuccess: "Account updated successfully",
  additionalEmailNotFound: "Additional email not found",
  additionalEmailRemovedSuccess: "Additional email removed successfully",
  additionalEmailSavedSuccess: "Additional email saved successfully",
  additionalUserInsertSuccess: "Additional user added successfully",
  additionalUserUpdateSuccess: "Additional user updated successfully",
  additionalEmailLimit: "You can only add up to {{limit}} extra email addresses. Please remove an existing one if you'd like to add a new one",
  additionalEmailLimitShort: "You can only add up to {{limit}} extra email addresses",
  addressBillingRequired: "Address billing is required",
  alertNotificationSavedSuccess: "Alert notification saved with success",
  cityBillingRequired: "The city billing is required",
  complementaryAddressBillingRequired: "Complementary address billing is required",
  confirmRegisterUserSuccess: "Thank you for confirming your email",
  countryBillingRequired: "The country billing is required",
  countryNotFound: "Country not found",
  emailExists: "Email address already exists",
  errorRegistration: "Model is empty",
  expirationDateSavedSuccess: "Expiration date saved with success",
  footerImageRequired: "The footer image is required",
  imageHeightLength: "Invalid image height",
  imageWidthLength: "Invalid image width",
  invalidEmailAddress: "Invalid email address",
  invalidLetterType: "Invalid letter type",
  invalidPhoneNumber: "Invalid phone number",
  invalidSubscriptionPlan: "Invalid subscription plan",
  invalidUserRole: "Invalid user role",
  letterheadSavedSuccess: "Letterhead saved with success",
  licenseExpired: "Your license has expired. For more details please contact the administrator",
  licenseNotFound: "No sufficient licenses are available. Please contact support@grantadvance.com",
  loginFailed: "Invalid user name or password",
  masterOnly: "Only master users have access to this resource",
  notEnoughLicense: "Your organization don't have any available license. If you want to add licenses please click here to purchase additional licenses",
  notificationExists: "Notification already exists",
  notificationNotFound: "Notification not found",
  funderQualifiedSuccess: "Funder qualified successfully",
  funderResetSuccess: "The funder has been reset successfully",
  funderDisqualifiedSuccess: "Funder disqualified successfully",
  funderPausedSuccess: "Funder qualification successfully paused",
  notificationTypeNotFound: "Notification type not found",
  organizationDisabled: "This organization is disabled. For more details contact the administrator.",
  organizationMainAddressUpdatedSuccess: "Organization main address updated with success",
  organizationNotFound: "Organization not found",
  organizationProfileSavedSuccess: "Organization profile saved with success",
  passwordModified: "Password modified successfully",
  passwordRecovery: "Please check your email to reset your password.",
  passwordReset: "Password reset successfully",
  postalCodeBillingRequired: "The zip code is required",
  profileNotFound: "Profile not found",
  provinceOrStateBillingRequired: "The state is required",
  help_center:"Help Center",
  profile_settings:"Profile Settings",
  hi:"Hi",
  user_profile:"User Profile",
  logout:"Logout",
  provinceOrStateNotFound: "State not found",
  sendActivationLinkSuccess: "Activation e-mail has been send successfully",
  sendPasswordResetSuccess: "Password reset e-mail has been send successfully",
  sendSetupPasswordSuccess: "Password setup e-mail has been send successfully",
  separatedLicenceExpirationDateError: "Expiration date of separated licenses cannot be greater than the expiration date of the main license",
  settingUpAccountSuccess: "Your account has been activated successfully. You can now login",
  signatureSavedSuccess: "Signature saved successfully",
  subscriptionPlanNotFound: "Subscription plan not found",
  userLogoutSuccess: "User logout successfully",
  userNameExists: "This User name is already taken",
  userNotAllowed: "User not allowed to login",
  userNotFound: "User not found",
  userProfileSavedSuccess: "User profile saved with success",
  wrongCurrentPassword: "Incorrect current password",
  additionalUsersRequired: "The additional users is required",
  addressRequired: "The address is required",
  amountDaysRequired: "The amount days is required",
  amountLicensesRequired: "The amount of licenses is required",
  planAmountRequired: "The plan amount is required",
  amountMonthsRequired: "The amount of months is required",
  amountYearsRequired: "The amount of years is required",
  planAmountRequired: "The plan amount is required",
  billingAddressLine2Required: "The complementary billing address is required",
  billingAddressRequired: "The billing address is required",
  billingCityRequired: "The billing city is required",
  billingCountryRequired: "The country billing is required",
  billingPostalCodeRequired: "The zip code is required",
  billingProvinceOrStateRequired: "The billing state is required",
  cityRequired: "The city is required",
  companyNameRequired: "The company name is required",
  businessEinRequired: "BN/EIN is required",
  compareConfirmPassword: "The password and confirmation password do not match.",
  complementaryAddressRequired: "The complementary address is required",
  confirmPasswordRequired: "The confirmation password is required",
  countryRequired: "The country is required",
  displayPlanRequired: "The display plan is required",
  emailRequired: "The email is required",
  firstNameRequired: "The first name is required",
  headerImageRequired: "The header image is required",
  invalidEmail: "This email is invalid",
  invalidRole: "Invalid user role",
  lastNameRequired: "The last name is required",
  licenseAmountRange: "The number of licenses must be greater than zero",
  licenseRequired: "The license is required",
  newPasswordRequired: "The new password is required",
  notificationTypeRequired: "The Notification type is required",
  oldPasswordRequired: "The old password is required",
  organizationIdRequired: "The organization id is required",
  passwordLength: "Your password must be between 6 and 20 characters long",
  passwordRequired: "The password is required",
  phoneRequired: "The phone number is required",
  planDescriptionRequired: "The plan description is required",
  postalCodeRequired: "The zip code is required",
  provinceOrStateRequired: "The state is required",
  roleRequired: "The role is required",
  signatureRequired: "The signature is required",
  subscriptionPlanNameRequired: "The subscription plan is required",
  tokenRequired: "The token is required",
  userIdRequired: "UserId is required",
  userNameRequired: "The login email is required",
  planNameRequired: "Internal plan name is required",
  customLetterRequired: "The custom letter is required",
  customLetterSavedSuccess: "Custom letter saved with success",
  customTagDeleteSuccess: "Custom tag removed successfully",
  customTagInsertSuccess: "Custom tag created successfully",
  customTagNotFound: "Custom tag not found",
  customTagUpdateSuccess: "Custom tag updated successfully",
  documentStateInsertSuccess: "Document state created successfully",
  inquiryLetterRequired: "The inquiry letter is required",
  inquiryLetterSavedSuccess: "Inquiry letter saved with success",
  proposalLetterRequired: "The proposal letter is required",
  proposalLetterSavedSuccess: "Proposal letter saved with success",
  userProjectRequired: "The user project is required",
  customDocumentTypeRequired: "The document type is required",
  documentAmountRequired: "The amount is required",
  documentFlaggedRequired: "The date is required",
  documentStateRequired: "The document state is required",
  tagDescriptionRequired: "The tag description is required",
  tagNameRequired: "The tag name is required",
  blockedFundersDeleteAllSuccess: "All funders unblocked successfully",
  blockedFundersDeleteSuccess: "Funder unblocked successfully",
  blockedFundersInsertSuccess: "Funder blocked successfully",
  blockedFundersNotFound: "Blocked Funder not found",
  customDatabaseDeleteSuccess: "Custom database successfully removed",
  customDatabaseFieldsMapRequired: "Please. Configure all the required fields before continue",
  customDatabaseNotFound: "Custom database not found",
  customDatabaseUserFieldsEmpty: "The list of configuration fields is empty",
  favoriteDeleteSuccess: "Favorite deleted successfully",
  favoriteDuplicateSuccess: "Favorite duplicated successfully",
  favoriteFundersDeleteSuccess: "Favorite funder deleted successfully",
  favoriteFundersInsertSuccess: "{{funders}} funders added to {{favCount}} favorites list",
  favoriteFundersNotFound: "Favorite funder not found",
  favoriteFundersUpdateSuccess: "Favorite funder update successfully",
  favoriteInsertSuccess: "Favorite created successfully",
  favoriteNotFound: "Favorite not found",
  favoriteUpdateSuccess: "Favorite update successfully",
  fundersListEmpty: "The funders list is empty",
  noteDeleteSuccess: "Note deleted successfully",
  noteInsertSuccess: "Note created successfully",
  noteNotFound: "Note not found",
  noteUpdateSuccess: "Note updated successfully",
  noteRequired: "Note is required before attaching any documents",
  notificationDateRequired: "The notification date is required",
  emailListRequired: "Select the e-mail",
  customDatabaseFileRequired: "The excel file is required",
  favoriteNameRequired: "The favorite name is required",
  favoriteRequired: "The favorite is required",
  funderQualifiedSuccess: "Funder qualified successfully",
  funderDisqualifiedSuccess: "Funder disqualified successfully",
  foundationRequired: "The funder is required",
  jsonUserFieldsMapRequired: "Please. Configure all the required fields before continue",
  labelTypeRequired: "The type of label is required",
  letterTypeRequired: "Select the type of document for print",
  noteDescriptionRequired: "The description is required",
  noteTitleRequired: "The title is required",
  bundleInsertSuccess: "Bundle created successfully",
  bundleNotFound: "Bundle not found",
  bundleTaskCount: "Enter at least one task",
  bundleTaskNotFound: "One or more task cannot be found",
  flagDateRequired: "The date is required",
  flagUpdateSuccess: "Flag updated successfully",
  projectBudgetCategoryDescriptionRequired: "The category description is required",
  projectBudgetDeleteSuccess: "Budget removed successfully",
  projectBudgetDescriptionExists: "This description already exists",
  projectBudgetInsertSuccess: "Budget added successfully",
  projectBudgetNotFound: "Budget not found",
  projectBudgetResetSuccess: "Budget reseted successfully",
  projectBudgetUpdateSuccess: "Budget updated successfully",
  projectEndDateRequired: "The end date is required",
  projectFundersDeleteSuccess: "Project funders removed successfully",
  projectFundersEmpty: "Please select at least one funder before continuing",
  projectFundersInsertSuccess: "{{funderAmount}} funders added to {{projectName}}",
  projectStartDateRequired: "The start date is required",
  taskDeleteSuccess: "Task removed successfully",
  taskEditSuccess: "Task updated successfully",
  taskInsertSuccess: "Task created successfully",
  taskListEmpty: "The task list is empty",
  taskNotFound: "Task not found",
  userProjectArchivedSuccess: "User project archived successfully",
  userProjectDeleteSuccess: "User project deleted successfully",
  userProjectEndDateRequired: "The end date is required",
  userProjectInsertSuccess: "User project created successfully",
  userProjectListEmpty: "Select one or more projects",
  userProjectNotFound: "Project not found",
  userProjectStartDateInvalid: "The start date is invalid",
  userProjectStartDateRequired: "The start date is required",
  userProjectUnarchivedSuccess: "User project unarchived successfully",
  userProjectUpdateSuccess: "User project updated successfully",
  budgetTypeInvalid: "The budget type is invalid",
  bundleDescriptionRequired: "The bundle description is required",
  bundleNameRequired: "The bundle name is required",
  bundleTaskRequired: "The task list is required",
  flagAmountInvalid: "The amount is invalid",
  flagAmountRequired: "The amount is required",
  flagStatusRequired: "The status is required",
  foundationNameRequired: "The funder name is required",
  foundationSourceTypeRequired: "The funder source is required",
  profileIdRequired: "The profile is required",
  projectBudgetAmountRequired: "The budget amount is required",
  projectBudgetDescriptionRequired: "The budget description is required",
  projectCostInvalid: "The project cost is invalid",
  projectCostRequired: "The project cost is required",
  projectDescriptionRequired: "The project description is required",
  projectNameRequired: "The project name is required",
  projectStatusInvalid: "The project status is invalid",
  taskDescriptionRequired: "The task description is required",
  taskNameRequired: "The task name is required",
  foundationInsertSuccess: "Funder added successfully",
  savedSearchDeleteSuccess: "Search deleted successfully",
  savedSearchDescriptionExists: "This description already exists",
  savedSearchInsertSuccess: "Search added successfully",
  savedSearchNotFound: "Saved search not found",
  savedSearchTypeInvalid: "The saved search type is invalid",
  savedSearchUpdateSuccess: "Search updated successfully",
  descriptionRequired: "The description is required",
  jsonFieldsRequired: "The search field is required",
  searchTypeRequired: "The search type is required",
  userProjectCompleted: "This Project is marked as completed",
  sendOnlineApplicationSuccess: "Online application message successfully sent",
  sendSuggestionSuccess: "Suggestion successfully sent",
  urlRequired: "The url is required",
  fundersRemovedSuccess: "{{fundersRemoved}} funder(s) have been removed from the current project",
  noteSubjectRequired: "The subject is required",
  accountDeleted: "This account was deleted. Contact the administrator",
  userRemovedSuccess: "Account removed successfully",
  userNameOrEmailRequired: "The User or e-mail name is required",
  fieldRequired: "This field is required",
  pickupNewPassword: "Please pick up new password",
  passwordMinCharacter: "Please enter at least {{minimumCharaters}} characters",
  enterSameValueAgain: "Please enter the same value again",
  feedbackSubmitted: "Feedback submitted successfully",
  feedbackInvalidGrantSize: "The grant size is invalid or too big",
  feedbackReviewUpdated: "Feedback review updated",
  announcementTitleRequired: "The announcement title is required",
  announcementDescriptionRequired: "The announcement description is required",
  announcementReleaseDateRequired: "The announcement release date is required",
  announcementReleaseDateInvalid: "Past dates are not allowed for the Release date",
  announcementTypeRequired: "The announcement type is required",
  announcementNotFound: "Announcement not found",
  announcementInsertSuccess: "Announcement added successfully",
  announcementUpdateSuccess: "Announcement updated successfully",
  announcementDeleteSuccess: "Announcement deleted successfully",
  funderDisqualifiedSuccess: "Funder disqualified successfully",
  funderQualifiedSuccess: "Funder qualified successfully",
  funderResetSuccess: "The funder has been reset successfully",
  funderPausedSuccess: "Funder qualification successfully paused",
  couponNameRequired: "The coupon name is required",
  couponCodeRequired: "The coupon code is required",
  couponCodeFormatInvalid: "The coupon code is invalid",
  codeLengthInvalid: "Maximum of 15 characters",
  couponExpirationDateRequired: "The coupon expiration date is required",
  couponExpirationMaxValue: "The date cannot be more than 6 months from today",
  couponExpirationDateInvalid: "Invalid expiration date",
  couponSubscriptionPlanRequired: "The coupon subscription plan is required",
  couponExtraMonthsAmountInvalid: "The extra month only allow number 1 to 99",
  couponDiscountAmountInvalid: "The discount only allow number 1 to 90",
  couponCodeAlreadyExist: "The coupon code has already been redeemed",
  couponSubscriptionNotFound: "The subscription plan not found",
  couponNotFound: "Coupon not found",
  couponSelectType: "Please select at least one coupon type (Extra Time/Discount and/or Unlock Plans)",
  couponInsertSuccess: "Coupon added succesfully",
  couponUpdateSuccess: "Coupon updated succesfully",
  couponDeleteSuccess: "Coupon deleted successfully",
  couponPauseUpdateSuccess: "Coupon updated successfully",
  deadlineEINRequired: "The EIN is required",
  deadlineFoundationNameRequired: "The funder name is required",
  deadlineCategoryRequired: "The category is required",
  deadlineURLRequired: "The deadline URL is required",
  deadlineCountryRequired: "The country is required",
  deadlineDateInvalid: "Only allow future dates",
  deadlineAmountToobig: "The grant amount too big",
  deadlineImportSuccess: "{{fileName}} imported successfully",
  deadlineImportSuccessWithWarning: "The file was imported successfully. However, some items have invalid data. Please update them accordingly",
  deadlineUpdateSuccess: "Deadline updated successfully",
  deadlineDeleteSuccess: "Deadline deleted successfully",
  deadlineRemovePopupMessage: "This action will remove this deadline",
  deadlineReviewCorrectInformation: "Please review and correct the information",
  deadlineInvalidFoundationDataField: "The provided funder data contains an invalid entry for the {{invalidData}} field.",
  deadlineInvalidFoundationDataFields: "The provided funder data contains invalid entries for the following fields: {{invalidData}}.",
  deadlineImportFilePrompt: "Do you want to import this file?",
  thankYouLetterSavedSuccess: "Thank you letter saved with success",
  impactReportLetterSavedSuccess: "Impact report letter saved with success",
  historyTypeRequired: "The history type is required",
  startDateRequired: "Start Date is required",
  startDateInvalid: "Please select a date that is later than today",
  dateMin: "Please select a date higher than today",
  referralNameCharityRequired: "Name charity is required",
  referralNameContactRequired: "Name contact is required",
  referralSubmitted: "Referral submitted successfully. Refer Another Charity",
  templateApplying: "Applying please wait...",
  templateApplyWarning: "Applying this may take a few minutes to complete",
  historyTimeline: {
    funderAdded: "Funder added to project",
    funderRemoved: "Funder removed from project",
    noteAdded: "Note added",
    foundationProfileView: "Funder profile viewed on project",
    customDoc: "Customized document",
    masterDoc: "Master document",
    createdOnProject: "created on project",
    deletedOnProject: "deleted on project",
    statusUpdated: "Status updated to",
    onProject: "on project"
  },
  referralNameCharityRequired: "Name of charity is required",
  referralNameContactRequired: "Name of contact is required",
  passwordNotMatch: "The password you entered doesn't match",
  emailAlreadyExist: "That email address is already registered. Please <a href='/' style='color: #02958a'>log in</a>",
  licenseRenewSuccess: "Your license renewal request has been successfully submitted. Our administration team will process your request soon.",
  emptyUsageReport: "The usage report was generated successfully, but it contains no data.",
  grantAmountRequired: "The Grant Amount is required",
  purposeRequired: "The purpose is required",
  dateAwardedRequired: "The date awarded is required",
  shareConsentRequired: "You must agree to the required terms to continue.",
  reportGrantSubmitted: "Your grant report has been submitted successfully",
  alertTitleRequired: "The alert title is required",
  passwordInvalid: "Incorrect password, try again",
  allAssignedLicensesActive: "All assigned licenses are active",
  someAssignedLicensesNotActive: "Some assigned licenses are not active",
  switchMainUserLicenseSuccess: "The main user license has been successfully switched.",
  licenseDeletedSuccessfuly: "License deleted successfully",
  errorDeletingLicense: "Error on deleting the license",
  upgradeDemoAccountSuccess: "Upgrade demo account completed successfully",
  skipPaymentReasonRequired: "The reason is required",
  funderQualificationInsertSuccess: "Funder qualification added successfully",
  funderQualificationUpdateSuccess: "Funder qualification updated successfully",
  funderQualificationDeleteSuccess: "Funder qualification deleted successfully",
  sectorInsertSuccess: "Sector added successfully",
  grantTypeInsertSuccess: "Grant type added successfully",
  stepStatusUpdated: "Review status updated successfully",
  missionStatementTooLong: "Mission statement cannot exceed 5,000 characters.",
  accountOwnershipChangedSuccess: "Ownership transferred successfully.",
  demoAccountDeletedSuccess: "Demo account deleted successfully",
  websiteInvalid: "This website is invalid"
};
